import apiClient from "../common/apiClient.js";

export default class LoginController {
  async Login(data) {
    try {
      return await apiClient.post("/login", data);
    } catch (error) {
      return error;
    }
  };
  async getMenu(token) {
    try {
      return await apiClient.get(
        "/tenant/get-role-access/",
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (error) {
      return error;
    }
  }


}
